// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__349vb","col":"styles_col__24icL","fulfillmentStatus":"styles_fulfillmentStatus__125zP","emailCol":"styles_emailCol__Oaw3U"};